<template>
  <DropDownInput
    :label="$t('calculator.profit-trend-form.select-month')"
    :dropdownTitle="$t('calculator.profit-trend-form.select-month.title')"
  >
    <template #value>
      {{ getMonthName(props.value) }}
    </template>
    <template #default="{hide}">
      <SimpleListItem
        v-for="index in monthsList"
        :key="index"
        :isSelected="index === props.value"
        @click.native="selectMonth(index, hide)"
      >
        {{ getMonthName(index) }}
      </SimpleListItem>
    </template>
  </DropDownInput>
</template>

<script setup lang="ts">
import DropDownInput from "@kano/components/ProfitCalculator/Form/DropDownInput.vue";
import SimpleListItem from "@kano/components/ProfitCalculator/Form/SimpleListItem.vue";
import { computed } from "vue";

const props = withDefaults(defineProps<{
  value: number,
  startMonth: number|null,
}>(),{
  startMonth: null,
});

const emit = defineEmits<{
  (event: 'input', value: number): void,
}>();

const monthsList = computed(() => {
  const months = Array.from({ length: 12 }, (v, i) => i);

  if (!props.startMonth) {
    return months;
  }

  return months.slice(props.startMonth, months.length);
})

const getMonthName = (monthIndex: number) => {
  const date = new Date();
  date.setDate(1);
  date.setMonth(monthIndex);
  return date.toLocaleString('default', { month: 'long' });
};

const selectMonth = (monthIndex: number, callback) => {
  emit("input", monthIndex);
  callback();
};
</script>